@if (_form != null) {
    <form [class.height100p]="fullHeight">         
        <app-sm-form-group [class.block-100]="fullHeight" [fullHeight]="fullHeight" [form]="_form" [fields]="_fields"></app-sm-form-group>
    </form>
}
